export const remToPx = (rem: string, bodyFontSize = 16) => {
    const remNum = parseFloat(rem.replace('rem', ''));
    const pxNum = remNum * bodyFontSize;
    return pxNum + 'px';
};

export const pxToRem = (px: string, bodyFontSize = 16) => {
    const pxNum = parseFloat(px.replace('px', ''));
    const remNum = pxNum / bodyFontSize;
    return remNum + 'rem';
};

export const toPx = (val: number): string => {
    return val + 'px';
};

export const toPct = (val: number): string => {
    return val + '%';
};
